/*
    搜索页面 状态管理
*/

const state = {
    operationtype: "replace",
    template: true, // 模板类型
    r_sort: "", // 筛选条件
    n: "" // 关键字
};

const mutations = {
    updateKeyWorld(state, payload) {
        state.n = payload;
    },
    updateFilter(state, payload) {
        state.r_sort = payload;
    },
    updateTemplate(state, payload) {
        state.template = payload;
    }
};

export default {
    state,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/search.js